import { find as _find } from 'lodash';
import { remove as _remove } from 'lodash';
import { filter as _filter } from 'lodash';
import { map as _map } from 'lodash';
import FormValidationService from './../../../common/services/FormValidationService';

class FinanceEditController {
  constructor(authService, $state, $stateParams, enums, loadingService, financeService, $scope, growl, utilsService) {
    "ngInject";

    if(!authService.validateUser(false, 'Enquiry', enums.PERMISSION_TYPE.Edit, true)) { return; }

    this.authService = authService;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.enums = enums;
    this.loadingService = loadingService;
    this.financeService = financeService;
    this.$scope = $scope;
    this.growl = growl;
    this.utilsService = utilsService;

    this.formValidationService = new FormValidationService()

    this.finance = {};

    this.panels = { };

    this.initialized = false;

    this.loadFinance();

    this.$scope.$on('saveFinance', this.editFinance.bind(this));
  }

  loadFinance() {
    const ctrl = this;

    ctrl.loadingService.showLoading('editFinance', 'Loading Finance ...');

    ctrl.financeService.getFinance(ctrl.$stateParams.financeId)
      .then(response => {
        Object.assign(ctrl.finance, response.data);
        ctrl.finance.referralCode = ctrl.finance.referralCode || 'Please Select';
        ctrl.finance.referralQuality = ctrl.finance.referralQuality || 'Please Select';
        ctrl.finance.installmentStart = ctrl.utilsService.getDatePart(ctrl.finance.installmentStart);
        
        ctrl.initialized = true;

        this.$scope.$broadcast('finance:initialized');
      })
      .catch(err => {

      })
      .finally(() => {
        ctrl.loadingService.hideLoading('editFinance');
      });
  }

  redirectToParent() {
    this.$state.go('dashboard');
  }

  editFinance(evt, params) {
    const ctrl = this;

    //if (!ctrl.formValidationService.validateForm()) { return; }

    this.state = 'Saving';

    //Data Cleansing
    ctrl.finance.referralCode = (ctrl.finance.referralCode === 'Please Select' ? null : ctrl.finance.referralCode);
    ctrl.finance.referralQuality = (ctrl.finance.referralQuality === 'Please Select' ? null : ctrl.finance.referralQuality);

    ctrl.loadingService.showLoading('editFinance', 'Saving Changes ...');

    ctrl.financeService.editFinance(ctrl.authService.authData.currentLocation.key, ctrl.finance)
      .then(response => {
        this.state = 'Saved';
        
        if (!params || (params && !params.skipNotification)) {
          this.growl.success('Changes to the finance quote updated successfully', {ttl: 5000});
        }        
      })
      .catch(err => {
        if (err.status === 400) { //Bad Request
          ctrl.state = 'ModelError';

          err.data.map(item => {
            ctrl.formValidationService.addModelError(item.key.substring(item.key.indexOf('.') + 1).toCamelCase(), item.value);
          });
        }
        else if (err.status === 500) {
          ctrl.state = 'SystemError';
          ctrl.formValidationService.addSystemError(null, "A system error occurred while processing your request. Please try again later or contact system administrator if problem persists.");
        }
      })
      .finally(() => {
        ctrl.loadingService.hideLoading('editFinance');
      });
  }

  acknowledge() {
    const ctrl = this;

    ctrl.loadingService.showLoading('editFinance', 'Acknowledge Finance ...');

    ctrl.financeService.acknowledge(ctrl.$stateParams.financeId)
      .then(response => { 
        this.growl.success('Changes to the finance quote updated successfully', {ttl: 5000});       
        ctrl.finance.acknowledged = true;
      })
      .catch(err => {

      })
      .finally(() => {
        ctrl.loadingService.hideLoading('editFinance');
      });
  }  
}

export default FinanceEditController;



// WEBPACK FOOTER //
// ./client/app/components/finance/financeEdit/financeEdit.controller.js